var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"claim__documents"},[_c('LennocReceiptUpload',{attrs:{"claimId":_vm.getClaimId,"documentId":_vm.documentId,"document":_vm.rootDocument,"environment":'portal',"dropzoneStrings":_vm.getDropzoneStrings,"supportedFileTypes":_vm.getSupportedFileTypes}}),(_vm.busy)?_c('LennocSpinner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }